import React from "react";

const Frontend = () => {
	return (
		<div className="skills_content">
			<h3 className="skills_title">Frontend</h3>

			<div className="skills_box">
				<div className="skills_group">
					<div className="skills_data">
						<i className="bx bxl-javascript"></i>

						<div>
							<h3 className="skills_name">JavaScript</h3>
						</div>
					</div>
					<div className="skills_data">
						<i className="bx bxl-html5"></i>

						<div>
							<h3 className="skills_name">HTML</h3>
						</div>
					</div>

					<div className="skills_data">
						<i className="bx bxl-css3"></i>

						<div>
							<h3 className="skills_name">CSS</h3>
						</div>
					</div>

					<div className="skills_data">
						<i className="bx bxl-bootstrap"></i>

						<div>
							<h3 className="skills_name">Bootstrap</h3>
						</div>
					</div>
				</div>

				<div className="skills_group">
					<div className="skills_data">
						<i className="bx bxl-react"></i>

						<div>
							<h3 className="skills_name">React</h3>
						</div>
					</div>

					<div className="skills_data">
						<i className="bx bxl-redux"></i>

						<div>
							<h3 className="skills_name">Redux</h3>
						</div>
					</div>

					<div className="skills_data">
						<i className="bx bxl-tailwind-css"></i>

						<div>
							<h3 className="skills_name">Tailwind</h3>
						</div>
					</div>

					<div className="skills_data">
						<i className="bx bxl-git"></i>

						<div>
							<h3 className="skills_name">Git</h3>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Frontend;
